<template>
  <div class="dataForm" style="min-width:800px;">
    <el-form
      ref="dataForm"
      :model="ruleForm"
      :rules="rules"
      label-position="top"
      label-width="100px"
      class="mb-20"
      :disabled="formDisabled"
    >
      <div class="underlineForm">
        <el-form-item label="所属公司" prop="titleId">
          <el-select :filterable="true" v-model="ruleForm.titleId" class="filter-item" placeholder="输入关键字搜索" clearable remote :disabled="Boolean(selectcCustomerTitleId) || itemDisabled" :remote-method="getTitleOptionRemote" @focus="getTitleOptionRemote('')" @change="handleCompanyTitleChange">
            <template v-if="titleOption.length">
              <el-option
                v-for="item in titleOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="税率" prop="rate">
          <el-select :filterable="true" v-model="ruleForm.rate" class="filter-item" placeholder="输入关键字搜索" clearable :disabled="Boolean(selectcCustomerTitleId) || itemDisabled">
            <template v-if="taxRateList.length">
              <el-option
                v-for="item in taxRateList"
                :key="item"
                :label="item + '%'"
                :value="item"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户公司名称" prop="customerCompanyId">
          <el-select :filterable="true"
v-model="ruleForm.customerCompanyId"
class="filter-item"
placeholder="输入关键字搜索"
clearable
remote
:disabled="itemDisabled"
@focus="companyRemoteMethod('')"
:remote-method="query => companyRemoteMethod(query)"
            @change="handleCompanyChange"
          >
            <template v-if="companyOption.length">
              <el-option
                v-for="item in companyOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.disable"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购买方抬头" prop="customerCompanyTicketTitleId">
          <el-select :filterable="true" v-model="ruleForm.customerCompanyTicketTitleId" class="filter-item" placeholder="输入关键字搜索" clearable @change="handleCustomerCompanyTicketTitleChange">
            <template v-if="customerCompanyTicketOption.length">
              <el-option
                v-for="item in customerCompanyTicketOption"
                :key="item.id"
                :label="item.titleName"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票名称" prop="titleName">
          <el-input v-model="ruleForm.titleName" type="input" class="filter-item" :disabled="itemDisabled || !id"></el-input>
        </el-form-item>
        <el-form-item label="税号" prop="taxId">
          <el-input v-model="ruleForm.taxId" type="input" class="filter-item" :disabled="itemDisabled || !id"></el-input>
        </el-form-item>
        <el-form-item label="开户银行" prop="bank">
          <el-input v-model="ruleForm.bank" type="input" class="filter-item" :disabled="itemDisabled || !id"></el-input>
        </el-form-item>
        <el-form-item label="银行账号" prop="account">
          <el-input v-model="ruleForm.account" type="input" class="filter-item" :disabled="itemDisabled || !id"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="registeredAddress">
          <el-input v-model="ruleForm.registeredAddress" type="input" class="filter-item" :disabled="itemDisabled || !id"></el-input>
        </el-form-item>
        <el-form-item label="电话号码 " prop="phone">
          <el-input v-model="ruleForm.phone" type="input" class="filter-item" :disabled="itemDisabled || !id"></el-input>
        </el-form-item>
        <el-form-item label="是否提交 " prop="submit">
           <el-checkbox v-model="ruleForm.submit" label="是否提交" size="large" />
        </el-form-item>
        <el-form-item label="备注" prop="mark" class="fullWidth">
          <template v-slot:label>
            备注 <span style="color:red">（如需拆分为多张发票，请在备注栏填写）</span>
          </template>
          <el-input v-model="ruleForm.mark" type="textarea" style="width: 100%" class="filter-item" clearable></el-input>
        </el-form-item>
        <div class="mb-20 fullWidth" v-if="canSubmit && mode !== 'approval'">
          <el-button @click="handleAddBusinessComand" type="primary">
            添加业务
          </el-button>
          <el-button @click="removeBusiness">
            移除业务
          </el-button>
        </div>
        <MiniBusinessList :businessList="ruleForm.details" @table-select="handleTableSelect">
          <template v-slot:before>
            <el-table-column type="selection" width="55" fixed="left"/>
            <el-table-column prop="no" label="业务编号" width="150" show-overflow-tooltip/>
          </template>
          <template v-slot:after>
            <el-table-column prop="name" label="业务名称"/>
            <el-table-column prop="brand" label="业务品牌"/>
            <el-table-column prop="model" label="型号"/>
            <el-table-column prop="serial" label="序列号"/>
            <el-table-column prop="amount" label="数量" width="80"/>
            <el-table-column prop="orderNo" label="订单号"/>
            <el-table-column prop="customerOrderNo" label="客户订单号"/>
          </template>
        </MiniBusinessList>
      </div>
    </el-form>
    <div style="display:flex;flex-flow:column" v-if="mode === 'approval'">
      <span style="margin-bottom:10px">申请理由</span>
       <el-input v-model="ruleForm.applyCancelReason" type="textarea" style="width: 80%" class="filter-item" clearable />
    </div>
    <div class="dialog-footer mt-20 " v-if="mode !== 'approval'">
      <el-button @click="cancle">
        {{ t('table.cancel') }}
      </el-button>
      <el-button
        type="primary"
        v-if="canSubmit"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ t('table.confirm') }}
      </el-button>
    </div>
    <el-dialog
      v-if="dialogVisible"
      v-model="dialogVisible"
      title="业务列表"
      width="80%"
      destroy-on-close
    >
      <BusinessList mode="table" ref="BusinessList" :customerCompanyId="ruleForm.customerCompanyId" :excludeIds="excludeIds" pageType="INVOICE" :titleId="ruleForm.titleId" :orderTaxRate="ruleForm.rate" />
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false" type="danger">取消</el-button>
          <el-button
            type="primary"
            @click="addBusiness"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref, watch } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { getPageList } from '@/apis/Form'
import { getTicketTitleDetailById } from '@/apis/TicketTitle'
import { getDetailById } from '@/apis/Dictionary'

import { ElMessage, ElForm } from 'element-plus'
import { createInvoice, updateInvoice } from '@/apis/invoice'

import BusinessList from '@/views/order/BusinessListDialog.vue'
import { useI18n } from 'vue-i18n'
import { debounce } from 'lodash'

import MiniBusinessList from '@/views/business/businessList/MiniBusinessList.vue'

export default defineComponent({
  components: {
    BusinessList,
    MiniBusinessList
  },
  props: {
    id: {
      type: Number,
      required: false,
      default: 0
    },
    dialogFormVisible: {
      type: Boolean,
      required: true
    },
    api: {
      type: String,
      required: true
    },
    handleResolveTempData: {
      type: Function,
      required: false
    },
    selectionBusiness: {
      type: Array,
      required: false,
      default: () => []
    },
    from: {
      type: String,
      required: false,
      default: 'invoice'
    },
    selectcCustomerCompanyId: {
      type: [String, Number],
      required: false,
      default: ''
    },
    selectcCustomerTitleId: {
      type: [String, Number],
      required: false,
      default: ''
    },
    selectoOderTaxRate: {
      type: Number,
      required: false,
      default: 0
    },
    mode: {
      type: String,
      required: false,
      default: ''
    },
    formDisabled: { type: Boolean, required: false, default: false },
    canSubmit: {
      type: Boolean,
      default: true
    }

  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref(ElForm)
    const BusinessList = ref({})

    const dataMap = reactive({
      from: props.from,
      mode: props.mode,
      id: props.id,
      submitLoading: false,
      itemDisabled: Boolean(props.canSubmit && props.id),
      ruleForm: {
        titleId: '',
        rate: 0,
        customerCompanyId: '',
        customerCompanyTicketTitleId: '',
        titleName: '',
        taxId: '',
        bank: '',
        account: '',
        registeredAddress: '',
        phone: '',
        mark: '',
        submit: true,
        businessIds: [],
        details: []
      },
      rules: {
        titleId: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        rate: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        customerCompanyId: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        titleName: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        customerCompanyTicketTitleId: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        taxId: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        bank: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        account: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        registeredAddress: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        phone: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        submit: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        details: []
      },
      titleOption: [],
      companyOption: [],
      customerCompanyTicketOption: [],
      dialogVisible: false,
      selectBusinessList: [],
      taxRateList: [],
      excludeIds: [],
      selectcCustomerTitleId: props.selectcCustomerTitleId,
      maxValueSingleInvoice: 0,
      handleCompanyChange() {
        dataMap.loadCustomerCompanyTicketTitle(true)
      },
      handleCompanyTitleChange(value: any) {
        dataMap.ruleForm.rate = 0
        dataMap.taxRateList = []

        if (value) {
          getTicketTitleDetailById(value).then((res: any) => {
            dataMap.taxRateList = res.taxRate
          })
        }
      },

      handleCustomerCompanyTicketTitleChange(value: any) {
        dataMap.ruleForm.titleName = ''
        dataMap.ruleForm.taxId = ''
        dataMap.ruleForm.bank = ''
        dataMap.ruleForm.account = ''
        dataMap.ruleForm.registeredAddress = ''
        dataMap.ruleForm.phone = ''
        if (value) {
          const ticketOption = dataMap.customerCompanyTicketOption.find(j => j.id === value) || {}
          dataMap.ruleForm.titleName = ticketOption.titleName
          dataMap.ruleForm.taxId = ticketOption.taxId
          dataMap.ruleForm.bank = ticketOption.bank
          dataMap.ruleForm.account = ticketOption.account
          dataMap.ruleForm.registeredAddress = ticketOption.registeredAddress
          dataMap.ruleForm.phone = ticketOption.phone
        }
      },
      handleTableSelect(selection: any) {
        dataMap.selectBusinessList = selection
      },
      companyRemoteMethod: debounce((query: string | number) => {
        getPageList('customerCompany/dropdown', {
          name: query,
          ids: props.selectcCustomerCompanyId
        }).then((res: any) => {
          dataMap.companyOption = res
            ? res.map((k: any) => {
              if (!k.salesManId) {
                k.disable = true
              } else {
                k.disable = false
              }
              return k
            })
            : []
        })
      }, 500),
      getTitleOptionRemote: debounce((query: string | number) => {
        getPageList(`ticketTitle/dropdown?name=${query}`).then((res: any) => {
          dataMap.titleOption = res || []
        })
      }, 500),
      loadCustomerCompanyTicketTitle(defaultData?: boolean) {
        if (!dataMap.ruleForm.customerCompanyId) {
          return
        }
        getPageList(`customerCompanyTicketTitle/page?size=999&customerCompanyId=${dataMap.ruleForm.customerCompanyId}`).then((res: any) => {
          if (props.selectcCustomerTitleId) {
            dataMap.customerCompanyTicketOption = res.data ? res.data.filter((k: any) => k.id === props.selectcCustomerTitleId) : []
          }
          dataMap.customerCompanyTicketOption = res.data || []
          if (defaultData) {
            const id = dataMap.customerCompanyTicketOption[0].id
            dataMap.ruleForm.customerCompanyTicketTitleId = id
            dataMap.handleCustomerCompanyTicketTitleChange(id)
          }
        })
      },
      handleAddBusinessComand() {
        if (!dataMap.ruleForm.titleId) {
          return ElMessage.error('请先选择所属公司！')
        }
        if (!dataMap.ruleForm.customerCompanyId) {
          return ElMessage.error('请先选择客户公司名称！')
        }
        dataMap.dialogVisible = true
      },
      getexcludeIds() {
        dataMap.excludeIds = dataMap.ruleForm.details.map((k: any) => {
          return k.businessId
        })
        return dataMap.excludeIds
      },
      addBusiness(array: any) {
        let tempArray = array && array.length ? array : (BusinessList.value as any).selectionArray
        console.log(tempArray, 'tempArray', dataMap.ruleForm)

        const limitNo = 8
        if (tempArray.length > limitNo) {
          const businessNameList = Array.from(new Set(tempArray.map((item: any) => item.name)))
          if (businessNameList.length > limitNo) {
            return ElMessage.error(`开票明细的业务最多不超过${limitNo}条！`)
          }
        }

        for (let i = 0; i < tempArray.length; i++) {
          const item = tempArray[i]
          if (dataMap.ruleForm.customerCompanyId !== item.customerCompanyId) {
            return ElMessage.error({
              message: '请选择同一个客户公司名称业务',
              duration: 1000
            })
          }
          if (dataMap.ruleForm.titleId !== item.titleId) {
            return ElMessage.error({
              message: '请选择订单所属公司和公司抬头的相同的业务',
              duration: 1000
            })
          }
          if (dataMap.ruleForm.rate !== item.orderTaxRate) {
            return ElMessage.error({
              message: '请选择订单税率和公司税率的相同的业务',
              duration: 1000
            })
          }
        }

        tempArray = dataMap.ruleForm.details.concat(tempArray)
        dataMap.ruleForm.details = (tempArray || []).map((item: any) => {
          return {
            ...item,
            businessId: item.businessId || item.id,
            name: item.name,
            price: item.price || 0
          }
        })
        dataMap.dialogVisible = false
      },
      removeBusiness() {
        if (!dataMap.selectBusinessList.length) {
          return ElMessage.error('请选择需要移除的业务！')
        }
        dataMap.ruleForm.details = dataMap.ruleForm.details.filter((k: any) => {
          return !dataMap.selectBusinessList.find(j => j.businessId === k.businessId)
        })
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              if (!dataMap.ruleForm.details.length) {
                return ElMessage.error('请选择开票业务！')
              }

              let orderFeeTotal = 0
              dataMap.ruleForm.businessIds = dataMap.ruleForm.details.map((k: any) => {
                orderFeeTotal += k.orderFee
                return k.businessId
              })

              const titleData = dataMap.titleOption.find((item: any) => item.id === dataMap.ruleForm.titleId)
              dataMap.maxValueSingleInvoice = titleData ? titleData.maxValueSingleInvoice : 0
              if (dataMap.ruleForm.businessIds.length > 1 && orderFeeTotal > dataMap.maxValueSingleInvoice) {
                return ElMessage.error(`多个业务不能超过发票抬头的最大值${dataMap.maxValueSingleInvoice}！`)
              }

              const tempData = {
                titleId: dataMap.ruleForm.titleId,
                rate: dataMap.ruleForm.rate,
                customerCompanyId: dataMap.ruleForm.customerCompanyId,
                customerCompanyTicketTitleId: dataMap.ruleForm.customerCompanyTicketTitleId,
                titleName: dataMap.ruleForm.titleName,
                taxId: dataMap.ruleForm.taxId,
                bank: dataMap.ruleForm.bank,
                account: dataMap.ruleForm.account,
                registeredAddress: dataMap.ruleForm.registeredAddress,
                phone: dataMap.ruleForm.phone,
                mark: dataMap.ruleForm.mark,
                businessIds: dataMap.ruleForm.businessIds,
                submit: dataMap.ruleForm.submit
              }

              const formSate = !props.id ? 'add' : 'edit'
              if (formSate === 'add') {
                await createInvoice(tempData)
              } else {
                await updateInvoice(props.id, tempData)
              }
              dataMap.submitLoading = false
              context.emit('update:visibel')
              context.emit('submit')
              ElMessage({
                message: !props.id ? '创建成功' : '编辑成功',
                type: 'success',
                duration: 2000
              })
            } catch (err: any) {
              console.log(err, 'err')
              dataMap.submitLoading = false
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      }
    })
    watch(() => dataMap.ruleForm.details, () => {
      dataMap.getexcludeIds()
    })
    onMounted(() => {
      dataMap.getTitleOptionRemote('')
      dataMap.companyRemoteMethod('')
      if (props.selectionBusiness.length) {
        dataMap.ruleForm.customerCompanyId = props.selectcCustomerCompanyId as any
        dataMap.ruleForm.titleId = props.selectcCustomerTitleId as any
        dataMap.ruleForm.rate = props.selectoOderTaxRate
        dataMap.addBusiness(props.selectionBusiness)
        dataMap.handleCompanyChange()
        dataMap.handleCompanyTitleChange(dataMap.ruleForm.titleId)
        dataMap.ruleForm.rate = props.selectoOderTaxRate
      }
      if (props.id) {
        getDetailById(props.api, props.id).then((res: any) => {
          dataMap.handleCompanyTitleChange(res.titleId)
          dataMap.ruleForm = res
          dataMap.loadCustomerCompanyTicketTitle()
          dataMap.ruleForm.details = res.details
            ? res.details.map((k: any) => {
              return {
                ...k,
                name: k.name,
                businessId: k.id
              }
            })
            : []
        })
      }
      dataMap.clearValidate()
    })
    return {
      t,
      ...toRefs(dataMap),
      dataForm,
      BusinessList
    }
  }
})
</script>
